export enum CartNotificationAction {
    LINE_ITEM_QTY_UPDATE = 'cart.lineItem.qtyUpdate',
    LINE_ITEM_AUTOSHIP_REMOVED = 'cart.lineItem.autoshipRemoved',
    SCHEDULED_DELIVERY_DATE_UPDATED = 'cart.scheduledDeliveryDate.updated',
    COUPON_EFFECT = 'cart.coupon.effect',
    DELIVERY_WINDOW_INVALID = 'cart.deliveryWindow.invalid',
    DISCONTINUED_ITEMS_REMOVED = 'cart.items.discontinuedRemoved',
    TREAT_POINTS_REMOVED = 'cart.treatPoints.removed',
}

/** `code` values when action is {@link CartNotificationAction.COUPON_EFFECT} (CPC-6938). */
export enum CartCouponEffectCode {
    AUTOSHIP_ONLY_NOT_ELIGIBLE = 'cart.coupon.autoshipOnlyNotEligible',
    PARTIAL_AUTOSHIP_APPLY = 'cart.coupon.partialAutoshipApply',
}
